(() => {
  const initializedTemplates = new WeakSet();
  const productsPerBanner = 10;

  const shuffle = (items) => {
    for (let index = items.length - 1; index > 0; index -= 1) {
      const randomIndex = Math.floor(Math.random() * (index + 1));
      [items[index], items[randomIndex]] = [items[randomIndex], items[index]];
    }

    return items;
  };

  const createBanner = (template, banner) => {
    const card = template.content.firstElementChild.cloneNode(true);
    const link = card.querySelector('.product-grid-banner__link');
    const image = card.querySelector('.product-grid-banner__image');
    link.href = banner.url;
    image.src = banner.src;
    image.alt = banner.alt;
    card.querySelector('.product-grid-banner__offer').hidden = !banner.sale;
    return card;
  };

  const decorateGrid = (template, container) => {
    const grid = container.querySelector('#product-grid.product-grid');
    if (!grid) return;

    grid.querySelectorAll(':scope > .product-grid-banner').forEach((banner) => banner.remove());

    let productCards = Array.from(grid.querySelectorAll(':scope > .grid__item[data-grouped-product-card]'));
    if (productCards.length < productsPerBanner) return;

    const directGridItems = Array.from(grid.querySelectorAll(':scope > .grid__item'));
    const hasExplicitSort = new URLSearchParams(window.location.search).has('sort_by');

    if (!hasExplicitSort && directGridItems.length === productCards.length) {
      productCards = shuffle(productCards);
      productCards.forEach((card, index) => {
        card.style.setProperty('--animation-order', index + 1);
        grid.append(card);
      });
    }

    const dataElement = template.nextElementSibling;
    if (!dataElement?.matches('[data-product-grid-banner-data]')) return;

    let banners;
    try {
      banners = shuffle(JSON.parse(dataElement.textContent));
    } catch (error) {
      return;
    }

    productCards.forEach((card, index) => {
      if ((index + 1) % productsPerBanner !== 0) return;
      const banner = banners[Math.floor(index / productsPerBanner) % banners.length];
      card.after(createBanner(template, banner));
    });
  };

  const initialize = (template) => {
    if (initializedTemplates.has(template)) return;

    const section = template.closest('.shopify-section') || document;
    const container = section.querySelector('#ProductGridContainer');
    if (!container) return;

    initializedTemplates.add(template);
    let observer;

    const render = () => {
      observer?.disconnect();
      decorateGrid(template, container);
      observer.observe(container, { childList: true });
    };

    observer = new MutationObserver(render);
    render();
  };

  const initializeAll = (root = document) => {
    root.querySelectorAll('[data-product-grid-banner-template]').forEach(initialize);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll());
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
